import { v4 as uuidv4 } from 'uuid';

function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  initialiseState({ state, commit }) {
    const storage = localStorage.getItem('storage');

    if (storage) {
      return commit('updateState', JSON.parse(storage));
    }

    if (!state.uid) {
      commit('updateState', { uid: uuidv4() });
    }
  },
  save({ commit }, { prop, value }) {
    commit('updateProp', { prop, value });
  }
};

const mutations = {
  updateState(state, obj) {
    state = Object.assign(state, obj);
    localStorage.setItem('storage', JSON.stringify(state));
  },
  updateProp(state, { prop, value }) {
    if (typeof state[prop] === 'object') {
      state[prop] = {
        ...state[prop],
        ...value
      };
    } else {
      state[prop] = value;
    }

    localStorage.setItem('storage', JSON.stringify(state));
  },
  reset(state) {
    Object.assign(state, initialState());
    localStorage.clear();
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
